module.exports = {"id":"202556","name":"Memphis Depay","rating":"80","photo":"./data/images/photos/2/202556.png","club":{"name":"OL","logo":"./data/images/clubs/OL.png"},"positions":["AG","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MemphisDepay0.json
// module id = 2972
// module chunks = 0